import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=6f8a2b22&scoped=true&"
import script from "./Customers.vue?vue&type=script&lang=js&"
export * from "./Customers.vue?vue&type=script&lang=js&"
import style0 from "./Customers.vue?vue&type=style&index=0&id=6f8a2b22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a2b22",
  null
  
)

export default component.exports